module.exports = __webpack_public_path__ + "img/greet_bg.3a76775c.png";